import React, { ChangeEvent, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import InputBirthDate from '../../../../components/InputBirthDate/InputBirthDate';
import { Main } from '../../styles';
import { DivInputContainer, Input, TagError } from './Styles';

interface IBirthDate {
  birthDate: string;
  setBirthDate: React.Dispatch<React.SetStateAction<string>>;
}

const BirthDateValidation: React.FC<IBirthDate> = ({
  birthDate,
  setBirthDate,
}) => {
  const { msg } = useSelector((state: ApplicationState) => ({
    msg: state.auth.status,
  }));

  const [errorBirthDate, setErrorBirthDate] = useState<boolean>(false);

  useEffect(() => {
    setErrorBirthDate(msg === 'Data de nascimento diferente da cadastrada');
  }, [msg]);

  return (
    <>
      <Main>
        <>
          <h1>Autenticação</h1>
          <p>Insira a data de nascimento para continuar</p>
        </>
      </Main>
      <InputBirthDate
        value={birthDate}
        error={errorBirthDate}
        setBirthDate={setBirthDate}
      />
    </>
  );
};

export default BirthDateValidation;
